import axios from "axios";
import { SnackbarProgrammatic as Snackbar } from "buefy";

const apiClient = axios.create({
  baseURL: "https://itp.mh-conseil.com",
  //baseURL: "https://localhost:8080",
  withCredentials: true, // This is the default
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
apiClient.isReady = false;

export default {
  intercept() {
    if (apiClient.interceptors.response.handlers.length == 0) {
      apiClient.interceptors.response.use(
        (response) => {
          if (
            response.config.method != "get" &&
            response.config.method != "post"
          ) {
            if (response.data.message !== undefined) {
              Snackbar.open({
                message: response.data.message,
                queue: false,
              });
            } /*else {
            Snackbar.open({
              message: response.data,
              queue: false
            });
          }*/
          }

          return Promise.resolve(response);
        },
        (error) => {
          Snackbar.open({
            message: error.response.data.message,
            type: "is-danger",
            queue: false,
          });

          return Promise.reject(error);
        }
      );
    }
  },
  getApiClient() {
    return apiClient;
  },

  // utilisateur
  SendMailResult(data) {
    return apiClient.post("/result_mail.php", data);
  },

  // utilisateur
  SendMailConnexion(data) {
    return apiClient.post("/connexion_mail.php", data);
  },
};
